import { Injectable, inject } from '@angular/core';
import { datadogRum, RumEvent } from '@datadog/browser-rum';
import { EnvironmentService } from '@util/environment';

@Injectable({
  providedIn: 'root',
})
export class ErrorTrackingService {
  private readonly env: EnvironmentService = inject(EnvironmentService);


  init(): void {
    if (window.location.host.startsWith('localhost')) {
      return;
    }

    datadogRum.init({
      applicationId: this.env.environment.datadog.applicationId,
      clientToken: this.env.environment.datadog.clientId,
      site: this.env.environment.datadog.site,
      service: 'health-hub',
      env: this.env.environment.country + '-' + this.env.environment.stage,
      version: this.env.info.version,
      sessionReplaySampleRate: 20,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      actionNameAttribute: 'data-cy',

      beforeSend: (event: RumEvent) => {
        // Since we are using a hash URL, replace this with a forward slash
        event.view.url = event.view.url.replace(/\/#\//, '/');

        return true;
      },
    });
  }
}
